import { PICTREE } from "../../constants";

const defaultAssetTable = {
  rows: [],
  summaryRow: null,
  colors: [],
};

const defaultRewardHoldings = {
  title: "宝くじ保有状況（上位）",
  rows: [],
};

const initialState = {
  summaryItems: [],
  summaryLoading: false,
  trustLevels: [],
  trustLoading: false,
  filterEventOptions: [],
  filterMunicipalityOptions: [],
  trendPoints: [],
  trendLoading: false,
  assetBreakdown: [],
  breakdownLoading: false,
  assetTable: defaultAssetTable,
  tableLoading: false,
  userRankingRows: [],
  rankingLoading: false,
  rewardSummaryCards: [],
  rewardLoading: false,
  rewardHoldings: defaultRewardHoldings,
  eventRows: [],
  eventLoading: false,
};

export default function pictreePlotReducer(state = initialState, action) {
  switch (action.type) {
    case PICTREE.SET_PLOT_SUMMARY_LOADING:
      return {
        ...state,
        summaryLoading: action.payload,
      };
    case PICTREE.SET_PLOT_SUMMARY_DATA:
      return {
        ...state,
        summaryItems: action.payload,
      };
    case PICTREE.SET_PLOT_TRUST_LOADING:
      return {
        ...state,
        trustLoading: action.payload,
      };
    case PICTREE.SET_PLOT_TRUST_DATA:
      return {
        ...state,
        trustLevels: action.payload,
      };
    case PICTREE.SET_PICTREE_PLOT_FILTER_EVENT_OPTIONS:
      return {
        ...state,
        filterEventOptions: action.payload || [],
      };
    case PICTREE.SET_PICTREE_PLOT_FILTER_MUNICIPALITY_OPTIONS:
      return {
        ...state,
        filterMunicipalityOptions: action.payload || [],
      };
    case PICTREE.SET_PLOT_TREND_LOADING:
      return {
        ...state,
        trendLoading: action.payload,
      };
    case PICTREE.SET_PLOT_TREND_DATA:
      return {
        ...state,
        trendPoints: action.payload,
      };
    case PICTREE.SET_PLOT_BREAKDOWN_LOADING:
      return {
        ...state,
        breakdownLoading: action.payload,
      };
    case PICTREE.SET_PLOT_BREAKDOWN_DATA:
      return {
        ...state,
        assetBreakdown: action.payload,
      };
    case PICTREE.SET_PLOT_TABLE_LOADING:
      return {
        ...state,
        tableLoading: action.payload,
      };
    case PICTREE.SET_PLOT_TABLE_DATA:
      return {
        ...state,
        assetTable: action.payload || defaultAssetTable,
      };
    case PICTREE.SET_PLOT_RANKING_LOADING:
      return {
        ...state,
        rankingLoading: action.payload,
      };
    case PICTREE.SET_PLOT_RANKING_DATA:
      return {
        ...state,
        userRankingRows: action.payload,
      };
    case PICTREE.SET_PLOT_REWARD_LOADING:
      return {
        ...state,
        rewardLoading: action.payload,
      };
    case PICTREE.SET_PLOT_REWARD_DATA:
      return {
        ...state,
        rewardSummaryCards: action.payload?.summaryCards || [],
        rewardHoldings: action.payload?.holdings || defaultRewardHoldings,
      };
    case PICTREE.SET_PLOT_EVENT_LOADING:
      return {
        ...state,
        eventLoading: action.payload,
      };
    case PICTREE.SET_PLOT_EVENT_DATA:
      return {
        ...state,
        eventRows: action.payload || [],
      };
    default:
      return state;
  }
}
